<template>
  <div>
    <div class="headbt">
      <span class="zjt" @click="fh"><img src="../../assets/img/zjt.png" ></span>密码修改&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </div>

    <div class="uinfo">
    	<div class="uinfo_1">
    	<ul class="list-group">
    	 <li class="list-group-item  userliebiao">
    	 	<div class=" col-sm-3 col-3 col-md-3" >
    			<span class="xingxing">*</span>原密码
    		</div>
    		<div class=" col-sm-9 col-9 col-md-9" >
    			<input v-model="formpas.oripass"  type="text" class="form-control" placeholder="请输入原密码"/>
    		</div>
    	 </li>
    	<li class="list-group-item  userliebiao">
    		<div class=" col-sm-3 col-3 col-md-3" >
    			<span class="xingxing">*</span>新密码
    		</div>
    		<div class=" col-sm-9 col-9 col-md-9" >
    			<input v-model="formpas.newpasswd"  type="password" class="form-control" placeholder="新密码,由字母和数字组成6到12位"/>
    		</div>
    	</li>

    	<li class="list-group-item  userliebiao">
    		<div class=" col-sm-3 col-3 col-md-3" >
    			<span class="xingxing">*</span>确认密码
    		</div>
    		<div class=" col-sm-9 col-9 col-md-9" >
    			<input v-model="formpas.reppasswd"  type="password" class="form-control" placeholder="确认密码,由字母和数字组成6到12位"/>
    		</div>
    	</li>

    	<li class="list-group-item  userliebiao" style="border-bottom: none !important;">
    		<div class="qrbc" @click="bc">确认保存</div>
    	</li>

    	</ul>
    	</div>
    </div>

    <div class="bkx">

    </div>

		<div class="footer ">
		  <div class="item_list_menu col-sm-3 col-3 col-md-3"  @click="tz('/base/index')">
			  <div class="dibumenu">
          	 <img src="../../assets/img/home.png" >
			</div>
			  <div class="xmtitle ">
			  	首页
			  </div>
		  </div>
			<div class="item_list_menu col-sm-3 col-3 col-md-3" @click="tz('/user/cprw')">
				<div class="dibumenu">
          	<!-- <img src="../../static/wd.png" > -->
             <img src="../../assets/img/cp.png" >
				</div>
				<div class="xmtitle ">
					测评任务
				</div>
			</div>
			<div class="item_list_menu col-sm-3 col-3 col-md-3" @click="tz('/user/wdcp')">
				<div class="dibumenu">
				 	 <img src="../../assets/img/wdcp.png" >
				</div>
				<div class="xmtitle ">
					我的测评
				</div>
			</div>
			<div class="item_list_menu col-sm-3 col-3 col-md-3" @click="tz('/user/index')">
				<div class="dibumenu">
					 <img src="../../assets/img/wd_xz.png" >
				</div>
				<div class="xmtitle xmtitle_active">
					我的
				</div>
			</div>
		</div>
  </div>
</template>

<script>
import {editpasswd } from '../../api/baseset'
  export default {
      data() {
        return {
          formpas:{
            oripass:'',
            newpasswd:'',
            reppasswd:''
          }
        }
      },
      mounted() {
      //this.getdata();
     // this.getsjtjs();
      },
      methods: {

        getdata(){



        },

        // 搜索事件
        search() {
          this.formInline.page = 1
          this.formInline.limit = 10
          this.getdata(this.formInline)
        },
        // 重置搜索
        formReset() {
          this.formInline.key = '';
        },
        shouli() {

        },
        chuli() {
          this.dialogVisible = true;
        },
        tz(url){

          this.$router.push(url);
        },
        fh(){
         window.history.go(-1);
        },
        bc(){
            if(this.formpas.oripass.length < 6){
              this.$message.error('原密码不能小于6位！')
              return ;
            }
            if(this.formpas.newpasswd.length < 6){
              this.$message.error('新密码不能小于6位！')
              return ;
            }
            if(this.formpas.newpasswd != this.formpas.reppasswd){
              this.$message.error('新密码和确认密码不一致！')
              return ;
            }
            this.loading = true
            //let userinfo =  localStorage.getItem('userdata');

            let param ={ oldPassword :this.formpas.oripass,newPassword:this.formpas.newpasswd}
               editpasswd(param)
                .then(res => {

                  this.loading = false
                  if (res.code != 200) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {

                    this.$message({
                      type: 'success',
                      message: res.msg
                    })
                  }
                })
                .catch(err => {
                  this.loading = false
                  this.$message.error('数据加载失败，请稍后再试！')
                })
        }
      }
    }
  </script>

<style scoped>
  	body{
  			background-color: #EFEFF4;
  		}

  		.footer {
  		  position: fixed ;
  		  bottom: 0;
  		  width: 100%;
  		  height: 60px; /* 底部栏的高度 */

  		  background-color: white;
  		  display: flex;
  		  border-top: solid 1px #E6EAEC;
       /* border: solid 1px red; */
        margin-left:  0 !important;
  		}
  		.item_list_menu{
  			/* border: solid 1px red; */
  			text-align: center;
  		}
  		.dibumenu{
  			width: 100%;
  			text-align: center;
  			padding-top: 3px;
  		}
  		.dibumenu img{
  			width: 24px;
  			height: 24px;
  		}
  		.xmtitle{
  			text-align: center;
  			font-size: 12px;
  			color: #666666;
  		}
  		.xmtitle_active{
  			color: #00DDA3;
  		}


    .list-group{
    	--bs-list-group-border-radius:0 0 0 0 !important;
    }

    .list-group-item{
    	border-radius: 0 0 0 0 ;
    	border: none !important;
    	padding:  0 0 0 0 !important;

    	height: 3rem;
    	line-height:3rem;
    	font-size: 14px;
    	color: #666666;
    	border-bottom: solid  1px #E6EAEC !important;
    }
    .list-group-item:first-child{
    	border-top-left-radius: 0;
    	border-top-right-radius: 0;

    }
    .item_list_menu{
    	/* border: solid 1px red; */
    	text-align: center;
    }
    .userliebiao{
    	display: flex;
    	font-size: 14px;
    	height: auto;
    	padding-top: 5px;
    	padding-bottom: 5px;
    	background-color: white;
    }
    .userinfo{
    	text-align: right;
    }
    .dibuxian{
    	width: 100%;
    	height: 90px;
    }
    .yjt img{
    	width: 24px;
    	height: 24px;
    }

    .bfwrxx_left{
    	text-align: left !important;
    	font-size: 18px  !important;
    	line-height: 40px !important;
    	padding-left: 2% !important;
    }
    .qrbc{
    	width:40%;
    	height: 30px;
    	margin: 0 auto;
    	text-align: center;
    	line-height: 30px;
    	color: white;
    	border-radius: 5px 5px 5px 5px;
    	background-color: #00DDA3;
    	margin-top: 15px;
    	margin-bottom: 10px;
    }
    .uinfo{
    	width: 100%;
    	height: auto;
    	padding-top: 5px;
    	padding-bottom: 5px;
    	background-color: white;
    }
    .uinfo_1{
    	width: 88%;
    	height: auto;
    	margin: 0 auto;
    }
    .bkx{
      width: 100%;
      height: 80px;
    }
    .list-group{
    	--bs-list-group-border-radius:0 0 0 0 !important;
    }

    .list-group-item{
    	border-radius: 0 0 0 0 ;
    	border: none !important;
    	padding:  0 0 0 0 !important;

    	height: 3rem;
    	line-height:3rem;
    	font-size: 14px;
    	color: #666666;
    	border-bottom: solid  1px #E6EAEC !important;
    }
    .list-group-item:first-child{
    	border-top-left-radius: 0;
    	border-top-right-radius: 0;

    }
    .uinfo_1{
    	width: 90%;
    	height: auto;
    	margin: 0 auto;
    }
    .userliebiao{
    	display: flex;
    	font-size: 14px;
    	height: auto;
    	padding-top: 5px;
    	padding-bottom: 5px;
    	background-color: white;
    }
    .userinfo{
    	text-align: right;
    }
    .form-control{
    	 border: none !important;
    	font-size: 14px;
    	height: 3rem;

    }
    .form-control:focus {
        outline: none;
        border-color: #ccc;
        border: none;
        -webkit-box-shadow: none;
        box-shadow: none;
    }

    .xingxing{
    	color:red;
    }

</style>



// WEBPACK FOOTER //
// src/views/user/upassedit.vue